module.exports = __webpack_public_path__ + "img/2.a3a21ced.jpg";